// extracted by mini-css-extract-plugin
module.exports = {"ul":"Text-module__ul___3jqvy Renderer-module__ul___m5JHJ"};